import {FormInstance} from "antd";

export function setFormErrors(err: any, form: FormInstance) {
    if(err?.status === 400) {
        let errors: ErrorFields[] = err.data.errorFields
        if(errors?.length > 0) {
            errors.forEach(({ field, error }) => {
                form.setFields([{name: field, errors:[error]}])
            });
        }
    }
}

type ErrorFields = {
    field: string
    error: string
}